export let AccountsUserGroup = /*#__PURE__*/function (AccountsUserGroup) {
  AccountsUserGroup["AccountManager"] = "Account Manager";
  AccountsUserGroup["Accounts"] = "Accounts";
  return AccountsUserGroup;
}({});